import { FullHeightContainer } from "./FullHeighContainer.js";
import { Dynamic } from "./dynamic.js";
import { FormGenerator } from "./formGenerator.js";
import { Helper } from "../util/helper.js";
import { General } from "../../../siteManagement/general.js";
import { Config } from "../config/config.js";
import { Commands } from "../util/commandManager.js";
import { LeftDrawerItem } from "./drawerItems.js";
import { ErrorBoundary } from "../../statistics/components/error_boundary.js";
import { MetaDataHelper } from "../util/metaDataHelper.js";
import { EventType } from "../../../siteManagement/eventManager.js";
import { CommonAppBaseProps, Metadata, Saveable } from "./commonApp.js";
import { MetadataRegion } from "./region.js";
import React from "react";
import ReactDOM from "react-dom";
export class TabStrip extends React.Component<TabStripProps, any>{
    private _tabstrip: kendo.ui.TabStrip;
    private _tabstripRef: any;
    private _currentIndex: number = 0;
    private _currentIndexInRenderedTabs: number = 0;
    private _vertical = false;
    private _tabStripContentWrapper: JQuery = null;
    private _tabsToRender: Array<InternalTab> = [];
    private _loadedTabs = {};
    private _onSearch: boolean = false;

    constructor(props) {
        super(props);
        this._vertical = props.horizontal !== true;

        if (this._vertical) {
            this._tabStripContentWrapper = General.Sheet.Manager.getTopMostSheet().elements.getLeftDrawerElementRef();
            this._tabStripContentWrapper.addClass("drawer__content--always-visible");
        }

        const tabsInMetadata = TabStrip.internalTabStateFromProps(props);

        this.markFirstTabAsLoaded(tabsInMetadata);
        this._switchTabByOutsideCommand();
        this.state = { tabs: tabsInMetadata, currentIndexInRenderedTabs: 0 };
    }


    private markFirstTabAsLoaded(tabsInMetadata: any[]) {
        if (tabsInMetadata.length > 0)
            this._loadedTabs[tabsInMetadata[0].guid] = true;
    }

    private static internalTabStateFromProps(props: any) {
        const tabsInMetadata = [];
        for (let i = 0; i < props.metadata.tabs.length; i++) {
            const tab: MetadataTab = props.metadata.tabs[i];
            const hasRegions = tab.regions !== undefined && tab.regions !== null && tab.regions.length > 0;
            let reactComponent = null;
            let moduleName = null;
            let appName = null;
            if (Helper.hasValue(tab.component)) {
                reactComponent = tab.component;
            }
            if (Helper.hasValue(tab.moduleName))
                moduleName = tab.moduleName;
            if (Helper.hasValue(tab.appName))
                appName = tab.appName;
            const currTab = {
                guid: props.metadata.tabs[i].guid ? (props.metadata.tabs[i].guid || "") + (moduleName || "") : i,
                hasRegions: hasRegions,
                reactComponent: reactComponent,
                moduleName: moduleName,
                appName: appName,
                props: tab.props,
                hasPlaceholder: tab.hasPlaceholder === true,
                content: null,
                metadataTab: tab
            };
            tabsInMetadata.push(currTab);
        }
        return tabsInMetadata;
    }

    static getDerivedStateFromProps(props, state) {
        return {
            tabs: TabStrip.internalTabStateFromProps(props)
        }
    }

    private _switchTabByOutsideCommand = () => {
        this.props.commandManager.registerExecutor("switchActiveTab", (command, data) => {
            if (command === Commands.DYNAMIC) {

                const isSameGuid = (guid1: string | number, guid2: string | number) => {
                    if (Helper.hasValue(guid1) && Helper.hasValue(guid2))
                        return ((guid1.toString().indexOf(guid2.toString()) > -1) || (guid2.toString().indexOf(guid1.toString()) > -1))
                    else
                        return false;
                }

                const nextTabs = this.props.metadata.tabs.filter(f => this._isTabSearchResult(f));
                const currentOpenGuid = Helper.hasValue(this._tabsToRender[this._currentIndexInRenderedTabs]) ? this._tabsToRender[this._currentIndexInRenderedTabs].guid : "";
                const nextActiveTab = (nextTabs.filter(f => isSameGuid(f.guid, currentOpenGuid)).length > 0) ? nextTabs.filter(f => isSameGuid(f.guid, currentOpenGuid))[0] : nextTabs[0]

                const nextActiveTabIndex = nextTabs.indexOf(nextActiveTab);
                const nextLoadedTab = this.props.metadata.tabs.indexOf(nextActiveTab);

                this._currentIndex = nextLoadedTab;
                this._currentIndexInRenderedTabs = nextActiveTabIndex;

                this._onSearch = true;
                this.setState({ currentIndexInRenderedTabs: this._currentIndexInRenderedTabs });
            }
        });
    }

    private _activateTab = (tabIndex: number) => {
        let indexInAllTabs = tabIndex;
        // Ermittlung Index tab in Metadaten aus index der gerenderten tabs
        if (this._vertical) {
            this._currentIndexInRenderedTabs = tabIndex;
            const metadataTab = this._tabsToRender[tabIndex].metadataTab;
            //this._tabsToRender.forEach((value, index) => { });
            this.state.tabs.forEach((tab, index) => {
                if (tab.metadataTab == metadataTab) {
                    indexInAllTabs = index;
                }
            })
            this.setState({ currentIndexInRenderedTabs: this._currentIndexInRenderedTabs });
        }

        const activatedTab = this.state.tabs[indexInAllTabs];
        const eventData = { index: indexInAllTabs, firstLoad: !activatedTab.loaded, component: activatedTab.reactComponent, moduleName: activatedTab.moduleName, appName: activatedTab.appName, contentUrl: activatedTab.contentUrl };
        this._currentIndex = indexInAllTabs;
        //if (!activatedTab.loaded) {
        const allTabs = this.state.tabs;
        allTabs[indexInAllTabs].loaded = true;
        this._loadedTabs[activatedTab.guid] = true;

        if (!this._vertical) {
            this.setState({ tabs: allTabs });
        }
        //}
        if (this._vertical) {
            this.setState({});
        }
        General.Events.trigger(EventType.Custom, { cmd: "tabStripTabSelected", data: eventData });
        $(window).trigger("tabStripTabSelected", eventData);
    }

    private _setTabStripRef = (ref) => {
        this._tabstripRef = ref;
    }

    private _shouldRenderTab = (tab: MetadataTab): boolean => {
        return !((tab.visible !== undefined && tab.visible === false) || (typeof (tab.visible) === "string" && !this.props.handleEval(tab.visible as string)));
    }

    private _isTabSearchResult = (tab: MetadataTab): boolean => {
        let countDisplayedRegions = 1;
        if (Array.isArray(tab.regions)) {
            const layoutRegions = MetaDataHelper.getLayoutRegions(tab.regions).map(r => r.guid);
            countDisplayedRegions = tab.regions.filter(f1 => layoutRegions.indexOf(f1.guid) === -1 && Array.isArray(f1.fields) && ((f1.fields.filter(f2 => !f2.noSearchResult).length > 0) && !f1.noSearchResult)).length;
        }
        return ((countDisplayedRegions > 0) && !Helper.getValueOrDefault(tab.noSearchResult, false));
    }

    public getTabStripRef = () => {
        return this._tabstrip;
    }

    componentDidMount() {
        if (!this._vertical) {
            this._tabstrip = $(this._tabstripRef).kendoTabStrip(
                {
                    animation: false,
                    activate: (e) => {
                        this._activateTab(this._tabstrip.select().index());
                    }
                }
            ).data("kendoTabStrip");

            $(document).on("refreshActiveTab", ".inno-tab-strip-wrapper .k-tabstrip-items .k-item.k-state-active", (ev, data) => {
                const idx = this._tabstrip.select().index();
                const activatedTab = this.state.tabs[idx];
                ev.stopPropagation();
            });
        }
    }

    componentWillUnmount() {
        if (this._vertical) {
            //this._tabStripContentWrapper.remove();
        } else {
            kendo.destroy(this._tabstrip.element);
        }
    }

    checkTabHasDirtyFields = (tab: InternalTab): boolean => {
        if (!tab.hasRegions) {
            return false;
        }
        for (const region of tab.metadataTab.regions) {
            if (region.fields) {
                for (const field of region.fields) {
                    if (this.props.apphelper && this.props.apphelper.isFieldDirty(field.model)) {
                        return true;
                    }
                }
            }
        }

        return false
    }

    render() {
        const tabTitle = [];
        const tabContent = [];
        this._tabsToRender = [];
        let lst = [];
        this.props.metadata.tabs.forEach((tab, index) => {
            let countDisplayedRegions = 1;
            if (Array.isArray(tab.regions)) {
                const layoutRegions = MetaDataHelper.getLayoutRegions(tab.regions).map(r => r.guid);
                countDisplayedRegions = tab.regions.filter(f1 => layoutRegions.indexOf(f1.guid) === -1 && Array.isArray(f1.fields) && ((f1.fields.filter(f2 => !f2.noSearchResult).length > 0) && !f1.noSearchResult)).length;
            }
            if ((countDisplayedRegions > 0) && !Helper.getValueOrDefault(tab.noSearchResult, false)) {
                lst.push({ title: tab.title, index: index });
            }
        });

        this.props.metadata.tabs.forEach((tab, index) => {

            let countDisplayedRegions = 1;
            if (Array.isArray(tab.regions)) {
                const layoutRegions = MetaDataHelper.getLayoutRegions(tab.regions).map(r => r.guid);
                countDisplayedRegions = tab.regions.filter(f1 => layoutRegions.indexOf(f1.guid) === -1 && Array.isArray(f1.fields) && ((f1.fields.filter(f2 => !f2.noSearchResult).length > 0) && !f1.noSearchResult)).length;
            }

            const condition1 = (countDisplayedRegions > 0) && !Helper.getValueOrDefault(tab.noSearchResult, false);
            const condition2 = lst.length == 0;

            if (condition1 || condition2) {
                const shouldRender = this._shouldRenderTab(tab) && this._isTabSearchResult(tab);
                //// Tab nicht sichtbar wenn der Tab generell visible=false gesetzt ist
                tabTitle.push(<li style={{ display: !shouldRender ? "none" : "" }} key={tab.guid || index} className={index == 0 ? "k-active" : ""} >{tab.title}</li>);
                const tabFromState = this.state.tabs[index];
                if (!this._loadedTabs[tabFromState.guid] && this._currentIndex != index) {
                    tabContent.push(<div key={tabFromState.guid || index} className="flex-container__item"></div>);
                }
                else if (tabFromState.hasRegions) { // Regionen          
                    tabContent.push(<div key={tabFromState.guid || index} className={"flex-container__item" + (this._vertical && this._currentIndex === index ? " active" : "")}>
                        <FormGenerator regions={tab.regions} entity={this.props.entity}
                            dataSources={this.props.dataSources} context={this.props.context} onChange={this.props.onChange} onDataLoaded={this.props.onDataLoaded}
                            handleEval={this.props.handleEval} handleIsSearchFieldFullObjectModel={this.props.handleIsSearchFieldFullObjectModel} commandManager={this.props.commandManager}></FormGenerator></div>);
                }
                else { // React Komponenten
                    var props = {};
                    $.extend(props, this.props, tabFromState.props, { commandManager: this.props.commandManager });
                    tabContent.push(<div key={tabFromState.guid || index} className={"flex-container__item" + (this._vertical && this._currentIndex === index ? " active" : "")}>  <ErrorBoundary><Dynamic {...props} componentName={tabFromState.reactComponent} moduleName={tabFromState.moduleName} appName={tabFromState.appName} />  </ErrorBoundary></div>)
                }

                if (this._vertical && shouldRender) {
                    this._tabsToRender.push(tabFromState);
                }
            }
        });

        return (
            this._vertical ?
                <FullHeightContainer classes="sheet__tab-pages">
                    {ReactDOM.createPortal(
                        <div ref={this._setTabStripRef} className="tabstrip__content">
                            {
                                ((this._tabsToRender.length > 1)) ?
                                    <>
                                        <label className="section-label">{Config.translations.sections}</label>
                                        {
                                            this._tabsToRender.map((tab, index) => {
                                                return (
                                                    <LeftDrawerItem
                                                        key={tab.guid}
                                                        hasChanges={this.checkTabHasDirtyFields(tab)}
                                                        label={tab.metadataTab.title}
                                                        icon={tab.metadataTab.iconName}
                                                        id={tab.guid.toString()}
                                                        onClick={(e) => {
                                                            if (this._tabsToRender.length > 1) {
                                                                this._onSearch = false;
                                                            }
                                                            this._activateTab(index);
                                                        }}
                                                        wrapperClass={this._currentIndexInRenderedTabs === index ? "current" : null}
                                                    />
                                                );
                                            })
                                        }
                                    </>
                                    : null
                            }
                        </div>
                        , this._tabStripContentWrapper[0]
                    )
                    }
                    {tabContent}
                </FullHeightContainer>
                :
                <div className="inno-tab-strip-wrapper flex-container__item">
                    <div ref={(r) => this._tabstripRef = r} className="inno-k-tab-strip flex-container">
                        <ul>
                            {tabTitle}
                        </ul>
                        {tabContent}
                    </div>
                </div>
        );
    }
};

interface InternalTab {
    guid: string | number;
    hasRegions: boolean;
    reactComponent: string;
    moduleName: string;
    appName: string;
    props: any;
    hasPlaceholder: boolean;
    content: string;
    metadataTab: MetadataTab;
}

export interface TabStripProps extends CommonAppBaseProps {
    metadata: Metadata;
    dataSources: {};
    translations?: any;
    handleIndividulFieldsMetaDataCreated?(metadata: any);
    horizontal?: boolean;
    sheet?: any;
    apphelper?: any;
    resolveModule?(moduleName: string): Saveable;
    debug?: boolean;
    onTabChange?(metadataTab: any): any;
}

export interface MetadataTab {
    iskey?: string;
    title: string;
    contentUrl?: string;
    hasPlaceholder?: boolean;
    component?: string;
    moduleName?: string;
    appName?: string;
    helpUrl?: string;
    props?: any;
    propsResolverName?: string;
    visible?: boolean | string;
    regions?: Array<MetadataRegion>;
    iconName?: string;
    guid?: string//Für den Editor. Die Reihenfolge der Tabs kann im Editor zur Laufzeit verändert werden. Deshalb kann der Index des Tabs nicht als Key verwendet werden.
    noSearchResult?: boolean;
    isSaveable?: boolean;
    additionalInfo?: AdditionalTabInfo;
    extendedView?: boolean | string;
}

export interface AdditionalTabInfo {
    type: string;
    apiId: string;
    refreshInterval: number;
    template: string;
    props: any
}